import { Edit, SimpleForm } from 'react-admin'
import { UpsertCustomer } from '~/components'

export const CustomersEdit = (props) => {
  return (
    <Edit mutationMode='undoable' {...props} redirect='show'>
      <SimpleForm warnWhenUnsavedChanges>
        <UpsertCustomer {...props} />
      </SimpleForm>
    </Edit>
  )
}

export default CustomersEdit
